import { render, staticRenderFns } from "./index3.5.1.vue?vue&type=template&id=c24b728c&scoped=true"
import script from "./index3.5.1.vue?vue&type=script&lang=js"
export * from "./index3.5.1.vue?vue&type=script&lang=js"
import style0 from "./index3.5.1.vue?vue&type=style&index=0&id=c24b728c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24b728c",
  null
  
)

export default component.exports